import React from 'react';
import { useIntl } from 'react-intl';
import { Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CheckCircleOutlineRoundedIcon from '@mui/icons-material/CheckCircleOutlineRounded';
import HighlightOffRoundedIcon from '@mui/icons-material/HighlightOffRounded';
import EditIcon from '@mui/icons-material/Edit';
import BranchSourcesEntry from './BranchSourcesEntry';
import CaptionValue from '../../../Components/CaptionValue/CaptionValue';
import StatusChip from '../../../Components/Chip/StatusChip';
import IconButton from '../../../Components/Button/IconButton';
import { CenteredFlexBox } from '../../../Components/FlexBox';

const BranchesListItems = function BranchesListItems({
  data,
  onClick,
  userInfo,
  toggleAccordion,
  expanded,
  branchSources,
  openEditBranchSourceDialog,
}) {
  const intl = useIntl();
  const { userRoles } = userInfo;
  const isSuperAdmin = userRoles?.find(({ roleId }) => roleId === 'SUPERADMIN');

  return (
    <Accordion
      id="accordion-branch"
      expanded={expanded === data.id}
      onChange={toggleAccordion(data.id)}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        sx={{ padding: '8px 16px' }}
      >
        <CaptionValue
          flex="1 1 30%"
          valueStyle={{ fontWeight: 500 }}
          caption={intl.messages.BRANCHNAME}
          value={data?.branchDescription}
        />
        <CaptionValue
          flex="1 1 30%"
          valueStyle={{ fontWeight: 500 }}
          caption={intl.messages.PHONENUMBER}
          value={data?.phoneNumber}
        />
        <CaptionValue
          flex="1 1 30%"
          valueStyle={{ fontWeight: 500 }}
          caption={intl.messages.EMAILADDRESS}
          value={data?.emailAddress}
        />
        <CaptionValue
          flex="1 1 10%"
          valueStyle={{ fontWeight: 500 }}
          caption={intl.messages.CALLS_TARGET}
          value={data?.target?.toString()}
        />
        <CenteredFlexBox width="160px" mr="16px" ml="16px">
          <StatusChip
            status={data?.active ? 'ACTIVE' : 'INACTIVE'}
            options={{
              ACTIVE: CheckCircleOutlineRoundedIcon,
              INACTIVE: HighlightOffRoundedIcon,
            }}
            colors={{ ACTIVE: '#34A853', INACTIVE: '#b00020' }}
          />
        </CenteredFlexBox>

        {isSuperAdmin && (
          <IconButton
            id="edit-branch"
            title="EDIT_BRANCH"
            size="large"
            onClick={(e) => {
              e.stopPropagation();
              onClick(data);
            }}
          >
            <EditIcon />
          </IconButton>
        )}
      </AccordionSummary>
      <AccordionDetails>
        {branchSources
          .filter((branchSource) => branchSource.branchId === data.id)
          .map((branchSource) => (
            <BranchSourcesEntry
              key={branchSource.id}
              branchSourcesData={branchSource}
              openEditBranchSourceDialog={openEditBranchSourceDialog}
            />
          ))}
      </AccordionDetails>
    </Accordion>
  );
};

export default BranchesListItems;
